/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import _ from 'lodash';

import { TransformedResponseProperty } from '@ibm-watson/shared/ts/catalog';

/**
 * Filters response properties to only show the properties that belong
 * to the lowest 2XX response
 * @param responseProperties from parser
 * @returns {array} Of filtered response properties.
 */
export const getFilteredResponseProperties = (
  responseProperties: TransformedResponseProperty[]
): TransformedResponseProperty[] => {
  const filteredResponseProperties = [];
  let lowestSuccessResponse = 0;
  responseProperties.forEach(property => {
    if (
      property.status &&
      property.status?.startsWith('2', 0) &&
      (lowestSuccessResponse === 0 ||
        parseInt(property.status) < lowestSuccessResponse)
    ) {
      lowestSuccessResponse = Number(property.status);
    }
  });
  for (var i = 0; i < responseProperties.length; i++) {
    const property = responseProperties[i];
    const propertyType = property.data_type;
    const propertyContent = property.content;
    const propertyStatus = Number(property.status);
    if (
      propertyStatus === lowestSuccessResponse &&
      (propertyType !== undefined ||
        (propertyContent && !_.isEmpty(propertyContent)))
    ) {
      filteredResponseProperties.push(_.cloneDeep(property));
    }
  }
  return filteredResponseProperties;
};
